import * as React from "react";
import classNames from "classnames";
import Checkbox from "./Checkbox";

export default function TextInputItemCheckbox({
  className,
  id,
  label,
  placeholder,
  value,
  mandatory,
  maxLength,
  onChange,
  onBlur,
  type = 'text',
  validate,
  checkboxLabel,
  checkboxValue,
  onCheckboxOnChange,
  checkBoxDisabled,
  showCheckBox = true,
  disabled,
  ...otherProps
}) {

  const error = (validate && validate(value));

  return (
    <div className={classNames(className, {
      'bn-error': error
    })}>
      <label htmlFor={id}>
        <div>{label} {mandatory && <span>*</span>}</div>
        {error && <div className={'bn-error'}>{error}</div>}
        {(!error && showCheckBox) && <div className={"bn-input-with-checkbox-container"}>
          <Checkbox id={id + '_checkbox'}
                    value={checkboxValue}
                    onChange={onCheckboxOnChange}
                    className={'bn-checkbox-item'}
                    label={"E-mail guest confirmation"}
                    disabled={checkBoxDisabled}
          /></div>}
      </label>
      <input type={type} id={id}
             value={value}
             maxLength={maxLength}
             placeholder={placeholder}
             onChange={onChange}
             onBlur={onBlur}
             disabled={disabled}
             {...otherProps}
      >
      </input>
    </div>
  )
}